module.exports = {
  apiHost: "https://api.lyndarumnorth.sensoreal.app",
  assetsHost: "https://assets.lyndarumnorth.sensoreal.app",
  brandName: "Lyndarum North",
  header: {
    text: { en: "Your Lyndarum North Selections" },
    logo: "",
    companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#e56a54",
    textColor: "#fff",
    font: "avenir",
  },
  contact: {
    website: "https://lyndarumnorth.avid.com.au",
    address: "220 Craigieburn Road East, Wollert",
    phone: "131 878",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "https://www.facebook.com/avjenningsbyavid/",
  },
  footerLogo: "",
};
